export default __webpack_public_path__ + "static/media/download.e1319ec4.svg";